import { Vocabulary } from './i18n';
import { ProjectTemplateColumnDef } from './project';

export { ProjectTemplateColumnDef, ProjectTemplateColumnDefId, ProjectTemplateColumnDefIds } from './project';

export type SequenceCode = {
  iupac: string;
  name: string;
};

export type RuleVersion = string;

export type AppState = 'draft' | 'edit' | 'update';

export type AppCartMode = 'client' | 'server';

export type AppAlertLevel = 'info' | 'error' | 'none';

export type StorageEncoding = 'binary' | 'blob' | 'none';

export type OligoInFocusData = {
  projectIdx: number;
  id: string;
};

export type ClientConfig = {
  addToCartMode: AppCartMode;
  tombstoneStart: number;
  alertLevel: AppAlertLevel;
  checkSessionOnLanding: boolean;
  storageEncoding: StorageEncoding;
  productFamilySku: string;
  cartRedirectDelaySecs: number;
  alertWebhookUrl?: string;
  skipLogoutOnStaleSession?: boolean;
  logoutIfSignedInOnStaleSession?: boolean;
  skipSessionCheckOnTabActivation?: boolean;
  logoutDelayMillis?: number;
  validBases3Prime?: string[];
  guestUserInvalid?: boolean;
  differentUserInvalid?: boolean;
  differentCountryInvalid?: boolean;
};

export const AppStates: {
  DRAFT: AppState,
  EDIT: AppState,
  UPDATE: AppState,
} = {
  DRAFT: 'draft',
  EDIT: 'edit',
  UPDATE: 'update',
};

export const AppCartModes: {
  CLIENT: AppCartMode;
  SERVER: AppCartMode;
} = {
  CLIENT: 'client',
  SERVER: 'server',
};

export type WorldData = {
  vocabulary: Vocabulary;
  sequenceCodes: SequenceCode[];
  ruleVersion: RuleVersion;
  language: string;
  templateColumnDefs: ProjectTemplateColumnDef[];
  templateSupportedExtensions: string[];
  maxNoOfOligos: number;
  clientConfig: ClientConfig;
};

export type WorldItem = {
  appState: AppState;
  countryCode: string;
  customerType: string;
  sessionToken?: string;
  oligoInFocus?: OligoInFocusData;
} & WorldData;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/models/world.ts